import { render, staticRenderFns } from "./TermsOfServiceView.vue?vue&type=template&id=7b8bda32"
import script from "./TermsOfServiceView.vue?vue&type=script&lang=ts"
export * from "./TermsOfServiceView.vue?vue&type=script&lang=ts"
import style0 from "./TermsOfServiceView.vue?vue&type=style&index=0&id=7b8bda32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports